import React from 'react';
import FAQ from "./components/faq";
import HomeHeader from "../components/HomeHeader";
import Footer from "../components/Footer";
import Email from "./components/Email";

const Terms = () => (<div>
  <div className="mt-5">
    <h3 className="bold">Legals</h3>
    <h4 className="mt-5 ms-3">
      <a className="bold" href="/termsofservice.html" target="_blank"><u>Terms of Service</u></a>
    </h4>
  </div>
</div>);

const Help = () => (<div className="body-bg full-height">
  <HomeHeader/>
  <div className="container">
    <div className="container-help">
      <Email/>
      <FAQ/>
      <Terms/>
    </div>
  </div>
  <Footer/>
</div>);

export default Help;
